import './App.css';
import Layout from './layout/Layout'
import Navbar from './navbar/Navbar';

function App() {
  return (
    <div className="container">
      <Navbar/>
      <Layout />
    </div>
  );
}

export default App;
